import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { CardBody } from 'reactstrap';
import toast from '../../utils/toast';
import { environment } from '../../environment/environment';
import CollapsibleCard from '../CollapsibleCard';

export default function ManageMatchingCriteria({ documentType, employerId }) {
  const [loading, setLoading] = useState(true);
  const matchingCriteriaDictionary = {
    id_number: 'ID Number',
    employee_no: 'Employee Number',
    bank_account_number: 'Bank Account Number',
    first_name: 'First Name',
    last_name: 'Last Name',
  };
  const [configuration, setConfiguration] = useState(null);
  const [error, setError] = useState(null);

  const toggleField = useCallback(
    (field) => {
      setError(null);
      let fields = configuration.configuration.matching_criteria.split(',');
      if (fields.includes(field)) {
        fields = fields.filter((f) => f !== field);
      } else {
        fields.push(field);
      }
      if (fields.length === 0) {
        setError('At least one matching criteria must be selected');
        return;
      }

      setConfiguration({
        ...configuration,
        configuration: {
          ...configuration.configuration,
          matching_criteria: fields.join(','),
        },
      });
    },
    [configuration]
  );

  const updateCriteria = () => {
    setLoading(true);
    axios
      .put(
        `${environment.baseUrl}/employer_features_config/${configuration.id}/update_feature_configuration/`,
        {
          configuration: configuration.configuration,
        }
      )
      .then(() => {
        setLoading(false);
        toast.success(`${documentType} matching criteria updated`);
      })
      .catch(() => {
        setLoading(false);
        setError('Failed to update matching criteria');
      });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${environment.baseUrl}/employer_features_config/feature_configuration/?employer_id=${employerId}&feature_name=${documentType}`
      )
      .then((res) => res.data)
      .then((data) => {
        setConfiguration(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError(`Failed to fetch employer ${documentType} configuration`);
      });
  }, [documentType, employerId]);

  return (
    <CollapsibleCard title={`${documentType} Matching Criteria`} className="shadow" style={{ marginTop: '20px' }}>
      <CardBody>
        {loading && (
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {configuration && (
          <div>
            <div className="form-group">
              {Object.keys(matchingCriteriaDictionary).map((key, index) => (
                <div className="form-check" key={index}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={configuration.configuration.matching_criteria
                      .split(',')
                      .includes(key)}
                    value=""
                    onChange={(e) => toggleField(key)}
                    id={`defaultCheck${index}`}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`defaultCheck${index}`}>
                    {matchingCriteriaDictionary[key]}
                  </label>
                </div>
              ))}
            </div>
            <div className="form-group">
              <label htmlFor="matching_criteria">Document length</label>
              <select
                className="form-control"
                id="matching_criteria"
                value={configuration?.configuration?.document_length || 1}
                onChange={(e) => {
                  const value = e?.target?.value;
                  if (!value) return;

                  const newValue = parseInt(value, 10);
                  if (Number.isNaN(newValue)) return;

                  setConfiguration({
                    ...configuration,
                    configuration: {
                      ...configuration.configuration,
                      document_length: newValue,
                    },
                  });
                }}>
                {Array.from(Array(5).keys()).map((key, index) => (
                  <option key={index} value={key + 1}>
                    {key + 1}
                  </option>
                ))}
              </select>
            </div>
            <button
              disabled={loading}
              onClick={updateCriteria}
              className="btn btn-primary btn-block">
              {loading ? 'Loading...' : 'Save Changes'}
            </button>
          </div>
        )}
      </CardBody>
    </CollapsibleCard>
  );
}
